import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

import RouteViewComponent from '../layouts/RouterBypass.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        meta: { requiresAuth: true, title: "Dashboard" },
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        meta: { requiresAuth: true, title: "Settings" },
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'users',
        path: 'users',
        meta: { requiresAuth: true, title: "Users" },
        component: () => import('../pages/users/UsersPage.vue'),
      },
      {
        name: 'sessions',
        path: 'sessions',
        meta: { requiresAuth: true, title: "Sessions" },
        component: () => import('../pages/sessions/SessionsPage.vue'),
      },
      {
        name: 'session',
        path: 'sessions/:sessionId',
        meta: { requiresAuth: true, title: "Session" },
        component: () => import('../pages/sessions/SessionPage.vue'),
      },
      {
        name: 'clientLogs',
        path: 'clientLogs',
        meta: { requiresAuth: true, title: "Client Logs" },
        component: () => import('../pages/clientLogs/ClientLogs.vue'),
      },
      {
        name: 'jira-admin',
        path: 'jira-admin',
        meta: { requiresAuth: true, title: "JIRA Admin" },
        component: () => import('../pages/jira-admin/JiraAdmin.vue'),
      },
      {
        name: 'cdn-scanner',
        path: 'cdn-scanner',
        meta: { requiresAuth: true, title: "CDN Scanner" },
        component: () => import('../pages/cdn-scanner/CdnScanner.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        meta: { title: "Login" },
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'signup',
        path: 'signup',
        meta: { title: "Signup" },
        component: () => import('../pages/auth/Signup.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        meta: { title: "Recover password" },
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        meta: { title: "Recover password" },
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        name: 'change-password',
        path: 'change-password/:token',
        meta: { title: "Change password" },
        component: () => import('../pages/auth/ChangePassword.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

import { getCookie } from '@/services/utils';
router.beforeEach((to) => {
  const loggedInUser = getCookie('bragg_lobby_user');

  if (to.meta.requiresAuth && !loggedInUser) {
    return {
      name: 'login',
      query: {
        redirect: to.fullPath,
      }
    };
  }

  if (to.meta?.title) {
    window.document.title = to.meta.title as string;
  }
});

const originalFetch = window.fetch;
;(window as any).fetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
  try {
    const res = await originalFetch(...args);

    if (!res.ok) {
      if (res.status === 401) {
        // window.returnUrl = window.location.hash.slice(1);
        await router.replace({
          name: 'login',
          query: { redirect: window.location.hash.slice(1) }
        });
      }
      throw new Error(`Request failed (${res.status}): ${res.statusText}`);
    }

    return res;
  } catch (err) {
    console.error("Global Fetch Error:", err);
    // Add global logging/alerts here
    throw err;
  }
};

export default router
